import loggerLocal from '@/utils/loggerLocal';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export async function waitForAuthReady (): Promise<void> {
    const auth = getAuth();

    return new Promise( ( resolve ) => {
        const unsubscribe = onAuthStateChanged( auth, ( user ) => {
            loggerLocal.info( '[waitForAuthReady] Auth state changed, user:', user );
            unsubscribe();
            resolve();
        } );
    } );
}

export async function waitForAuthReadyWithTimeout ( ms = 8000 ) {
    return Promise.race( [
        waitForAuthReady(), // la tua funzione attuale
        new Promise( ( _, rej ) => setTimeout( () => rej( new Error( 'waitForAuthReady timeout' ) ), ms ) )
    ] );
}